// localStorageHelper.js

const STORAGE_LIFETIME_MS = 1 * 60 * 1000; // 1 minute

export const StorageKeys = {
    LOCATION: (id) => `location:${id}`,
};

/**
 * Save data to localStorage with a timestamp.
 */
export function saveToLocalStorage(key, data) {
    const wrapped = {
        timestamp: Date.now(),
        value: data,
    };

    try {
        localStorage.setItem(key, JSON.stringify(wrapped));
    } catch (e) {
        console.warn(`Failed to save ${key} to localStorage:`, e);
    }
}

/**
 * Get data from localStorage if it's still valid (not expired).
 */
export function getFromLocalStorage(key, lifetimeMs = STORAGE_LIFETIME_MS) {
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        if (Date.now() - parsed.timestamp > lifetimeMs) {
            localStorage.removeItem(key); // expired
            return null;
        }

        return parsed.value;
    } catch (e) {
        console.warn(`Failed to load ${key} from localStorage:`, e);
        return null;
    }
}

/**
 * Remove a key manually
 */
export function removeFromLocalStorage(key) {
    localStorage.removeItem(key);
}
